<template>
  <wrap-container>
    <wrap-container
      class="qr-container"
      :class="{ isLoading }"
      :quantumObfuscate="quantumObfuscate"
    >
      <vue-qrcode
        class="qr-code"
        :class="{ isLoading }"
        :scale="scale"
        :errorCorrectionLevel="errorCorrectionLevel"
        :value="urlFinal"
      />
      <wrap-container v-if="isLoading" class="qr-loader">
        <loader color="#f5f4f4" />
      </wrap-container>
    </wrap-container>
  </wrap-container>
</template>

<script>
import om from "@/api";
import VueQrcode from "vue-qrcode";
import Loader from "@/components/core/custom/Loader";
import WrapContainer from "@/components/core/Container";

export default {
  name: "OpenmarketQR",
  components: {
    VueQrcode,
    Loader,
    WrapContainer
  },
  props: {
    url: String,
    scale: Number,
    enableShortener: {
      type: Boolean,
      default: true
    },
    errorCorrectionLevel: {
      type: String,
      default: "L"
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      urlCorta: null,
      isLoading: true
    };
  },
  mounted() {
    if (this.enableShortener) {
      om.acortarUrl(this.url)
        .then(response => {
          if (response.data.status === "OK") {
            this.urlCorta = response.data.respuesta.uri;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
  },
  computed: {
    urlFinal() {
      return this.urlCorta ?? this.url;
    },
    escalaQrFinal() {
      return this.escalaQr;
    }
  }
};
</script>

<style scoped>
.qr-container {
  display: inline-block;
  position: relative;
}

.qr-container.isLoading {
  display: inline-block;
  position: relative;
  background-color: #f5f4f4;
}

.qr-code {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.qr-code.isLoading {
  opacity: 0;
}

.qr-loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
